import { motion } from "framer-motion";

const SPECS = [
  { label: "Height", value: "5'3\"" },
  { label: "Weight", value: "155 lbs" },
  { label: "Hair", value: "Brown" },
  { label: "Eyes", value: "Brown" },
  { label: "Valid Passport", value: "Yes" },
];

export default function SpecsBar() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 1.1 }}
      className="relative border-t border-white/10 bg-surface/50 backdrop-blur-sm"
      data-testid="specs-bar"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16 py-5 flex flex-wrap items-center gap-x-8 gap-y-3">
        {SPECS.map((s, i) => (
          <div key={s.label} className="flex items-center gap-8">
            <div className="flex items-baseline gap-2.5">
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-hdim">{s.label}</span>
              <span className={`font-mono text-xs sm:text-sm font-bold tracking-wider ${s.value === "[Color]" ? "text-hdim" : "text-white"}`}>
                {s.value}
              </span>
            </div>
            {i < SPECS.length - 1 && <span className="h-3 w-px bg-white/15 hidden sm:block" />}
          </div>
        ))}
      </div>
    </motion.div>
  );
}
